import apiService from './apiService';

const billingService = {
  getConfig: () => apiService.get('/billing/config'),
  getPlans: () => apiService.get('/billing/plans'),
  getUsage: () => apiService.get('/billing/usage'),
  createOrder: ({ planId, userCount, billingCycle, couponCode }) =>
    apiService.post('/billing/order', { planId, userCount, billingCycle, couponCode }),
  quote: ({ planId, userCount, billingCycle, couponCode }) =>
    apiService.post('/billing/quote', { planId, userCount, billingCycle, couponCode }),
  verify: ({ razorpayOrderId, razorpayPaymentId, razorpaySignature }) =>
    apiService.post('/billing/verify', {
      razorpayOrderId,
      razorpayPaymentId,
      razorpaySignature,
    }),
  listTransactions: (params = {}) => apiService.get('/billing/transactions', { params }),
  invoiceUrl: (txnId) => `/api/billing/invoice/${txnId}`,
};

// Lazy-load the Razorpay Checkout JS script. Resolves to true once
// `window.Razorpay` is available; safe to call multiple times.
export const loadRazorpayCheckout = () =>
  new Promise((resolve) => {
    if (typeof window === 'undefined') return resolve(false);
    if (window.Razorpay) return resolve(true);
    const existing = document.getElementById('razorpay-checkout-js');
    if (existing) {
      existing.addEventListener('load', () => resolve(Boolean(window.Razorpay)));
      existing.addEventListener('error', () => resolve(false));
      return;
    }
    const script = document.createElement('script');
    script.id = 'razorpay-checkout-js';
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => resolve(Boolean(window.Razorpay));
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

export default billingService;
